"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO_COUNTRY_CODES = exports.BLOCKED_COUNTRY_CODES = void 0;
exports.isBlockedCountry = isBlockedCountry;
exports.isValidCountryCode = isValidCountryCode;
exports.getCountryFlag = getCountryFlag;
exports.getCountryName = getCountryName;
exports.getSelectableCountries = getSelectableCountries;
/** ISO 3166-1 alpha-2 codes blocked from profile country selection (sanctions). */
exports.BLOCKED_COUNTRY_CODES = ["CU", "IR", "KP", "SY"];
exports.ISO_COUNTRY_CODES = [
    "AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU",
    "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL",
    "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC",
    "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CV", "CW",
    "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH",
    "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE",
    "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU",
    "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN",
    "IO", "IQ", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM",
    "KN", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT",
    "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM",
    "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ",
    "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM",
    "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW",
    "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG",
    "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX",
    "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR",
    "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE",
    "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW",
];
function isBlockedCountry(code) {
    if (!code)
        return false;
    return exports.BLOCKED_COUNTRY_CODES.includes(code.trim().toUpperCase());
}
function isValidCountryCode(code) {
    if (!code)
        return true;
    const normalized = code.trim().toUpperCase();
    if (isBlockedCountry(normalized))
        return false;
    return exports.ISO_COUNTRY_CODES.includes(normalized);
}
function getCountryFlag(code) {
    const normalized = code.trim().toUpperCase();
    if (normalized.length !== 2)
        return "";
    return normalized
        .split("")
        .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
        .join("");
}
function getCountryName(code, locale = "en") {
    const normalized = code.trim().toUpperCase();
    try {
        const displayNames = new Intl.DisplayNames([locale], { type: "region" });
        return displayNames.of(normalized) ?? normalized;
    }
    catch {
        return normalized;
    }
}
function getSelectableCountries(locale = "en") {
    return exports.ISO_COUNTRY_CODES.map((code) => ({
        code,
        name: getCountryName(code, locale),
        flag: getCountryFlag(code),
    })).sort((a, b) => a.name.localeCompare(b.name, locale));
}
